import React from 'react';
import { Image } from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import { backgroundThemeState } from '../../../../../atoms';
import { useAnimationForBackGround } from '../../../../../util/hooks';
import { BackgroundImageProps } from './BackgroundImage';
import classNames from './Theme.module.scss';

export interface InvertFilterProps extends BackgroundImageProps {
  inEnterState?: boolean;
  access?: boolean;
  imageUrl?: string;
  classNames?: string;
}

export const InvertFilter: React.FC<
  React.PropsWithChildren<unknown> & InvertFilterProps
> = ({
  children,
  inEnterState,
  access,
  style,
  className,
  width = '100%',
  height = '100%',
}) => {
  const background = useRecoilValue(backgroundThemeState);
  useAnimationForBackGround(inEnterState!, access!, className!);

  return (
    <div
      style={{ height: inEnterState ? '100%' : '100vh' }}
      className={className + ' ' + classNames.invertFilter}
    >
      {children}
      <Image
        src={background}
        width={width}
        height={height}
        alt={'invert filter'}
        style={style}
      />
    </div>
  );
};
